// @flow

import React, { Component, Fragment } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { FormattedMessage } from "react-intl";
import { getClassName } from "ui-kit/utils/component";
import { Page } from "components";
import { getNotifications, goToInvestPage } from "ducks/user/actions";

import Notification from "./notification";

import "./Notifications.scss";

export const ccn = getClassName("Notifications");

type StateProps = {
  authorized: boolean
};

class Notifications extends Component {
  state = {
    loader: true,
    extraClass: " page-notifs"
  };

  componentWillMount() {
    this.props.getNotifications();
  }

  componentWillReceiveProps(next) {
    if (
      this.props.user &&
      next.user &&
      this.props.user.loader !== next.user.loader
    ) {
      this.setState({ loader: next.user.loader });
    }
  }

  componentWillUnmount() {
    this.props.notifications.length = 0;
  }

  render() {
    const { notifications } = this.props;

    const skipNotifications = [550];
    return (
      <Fragment>
        <Page {...this.state} className="testPage">
          <div className={ccn("container")}>
            <h1 className={ccn("title")}>
              <FormattedMessage
                id="hbc.notification.title"
                defaultMessage="Notifications"
              />
            </h1>
            {notifications && notifications.length > 0 ? (
              <div className={ccn("blk")}>
                {notifications.map(notification => (
                  skipNotifications.includes(notification.type)
                    ? null
                    : <Notification key={notification.id} {...notification} />
                ))}
              </div>
            ) : (
              <div style={{ fontSize: "1.4em" }}>
                <FormattedMessage
                  id="hbc.notification.no.notifications"
                  defaultMessage="No notifications"
                />
                .{" "}
                <button href="#" onClick={() => this.props.goToInvestPage()}>
                  <FormattedMessage
                    id="hbc.notification.no.notifications.invest.now"
                    defaultMessage="Invest Now"
                  />
                </button>
              </div>
            )}
          </div>
        </Page>
      </Fragment>
    );
  }
}

const mapStateToProps = (state): StateProps => ({
  notifications: state.user.notifications,
  user: state.user
});

export default withRouter(
  connect(
    mapStateToProps,
    { getNotifications, goToInvestPage }
  )(Notifications)
);



// WEBPACK FOOTER //
// ./src/containers/notifications/Notifications.js